<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import { generateBreadcrumbsForUrl } from '@/services/navigationService'
import { __ } from '@/utils/utils'

defineProps({
  title: String,
  subTitle: String,
  logo: String,
  backgroundLogo: String
})

const lang = ref<any>()
const breadcrumbs = ref<any>([])
const siteUrl = `${document.location.origin}/`
const route = useRoute()
const lvl3Index = ref<any>(0)

onMounted(async () => {
  breadcrumbs.value = await generateBreadcrumbsForUrl('company', route.params.menu_second as string)
  lvl3Index.value = breadcrumbs.value.findIndex((item: any) => item.url === route.params.slug)

  lang.value =
    localStorage.getItem('lang') !== '' &&
    localStorage.getItem('lang') !== 'undefined' &&
    localStorage.getItem('lang') !== 'en'
      ? localStorage.getItem('lang') + '/'
      : ''
})
</script>
<template>
  <div
    v-if="backgroundLogo"
    :class="`bg-black  bg-cover bg-no-repeat bg-center flex w-full justify-center`"
    :style="{ backgroundImage: `url('${backgroundLogo}')` }"
  >
    <div
      class="flex flex-col items-center lg:pb-[230px] pb-20 lg:pt-10 w-full max-w-[800px] lg:max-w-[1000px] 1200:max-w-[1200px]"
    >
      <div class="gap-[2px] flex self-start lg:pl-0 pl-[10px] lg:pt-0 pt-[20px]">
        <a :href="`${siteUrl}${lang}`" class="text-red-150">{{ __('Home') }}</a>
        <span class="text-white">></span>
        <a :href="`${siteUrl}${lang}company/contact-us/`" class="text-red-150">
          {{ breadcrumbs[0]?.title }}
        </a>
        <span class="text-white">></span>

        <div class="text-white pointer-events-none">
          {{ __('Sponsorships') }}
        </div>
      </div>
      <div
        class="flex flex-col lg:flex-row lg:mt-[101px] mt-[37px] gap-10 lg:gap-0 md:px-20 lg:pl-0 lg:pr-[40px] w-full"
      >
        <div
          class="self-center text-center text-wrap text-white lg:h1-bold h3-bold lg:self-start lg:text-start 1200:max-w-[950px] max-w-[700px] lg:max-w-[750px]"
          v-html="title"
        ></div>
      </div>

      <div
        class="self-center h-[61px] text-white lg:h5-bold nav lg:self-start lg:mt-[10px] mt-[8px] text-center lg:text-left md:px-20 lg:px-0 px-[10px]"
        v-html="subTitle"
      ></div>
    </div>
  </div>
</template>
